import React, { useState } from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const ConsultantsWithAccessForm = _ref => {
  let {
    consultantsAndAdmins,
    claimGroup,
    handleConsultantToClaimGroupCreate,
    size = 'sm',
    isUnderReview
  } = _ref;
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = e => {
    const consultant = consultantsAndAdmins.find(consultant => consultant.id === +e.target.value);
    setSelectedConsultant(consultant);
  };
  const submit = () => {
    handleConsultantToClaimGroupCreate({
      ...selectedConsultant,
      role: selectedRole
    });
    setSelectedRole('');
    setSelectedConsultant('');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: size === 'lg' ? 2 : 1
  }, t('consultant'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: size === 'lg' ? 4 : 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    size: "md",
    name: "consultant_id",
    onChange: e => handleChange(e),
    type: "text",
    placeholder: "Small text",
    value: selectedConsultant?.id || '',
    disabled: isUnderReview
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), consultantsAndAdmins.sort((a, b) => a.name.localeCompare(b.name)).map(c => {
    return /*#__PURE__*/React.createElement("option", {
      key: c.id,
      value: c.id
    }, c.name);
  }))), /*#__PURE__*/React.createElement(Col, {
    md: size === 'lg' ? 4 : 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    size: "md",
    name: "role",
    onChange: e => setSelectedRole(e.target.value),
    type: "text",
    placeholder: "Small text",
    value: selectedRole,
    disabled: isUnderReview
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), /*#__PURE__*/React.createElement("option", {
    value: 'claim_group_access_lead_consultant'
  }, "Lead Consultant"), /*#__PURE__*/React.createElement("option", {
    value: 'claim_group_access_suporting_consultant'
  }, "Supporting Consultant"))), /*#__PURE__*/React.createElement(Col, {
    md: size === 'lg' ? 2 : 1
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !selectedConsultant || !selectedRole || isUnderReview,
    variant: "link",
    onClick: submit
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add')))));
};
export default ConsultantsWithAccessForm;